import { useEffect, useState } from "react";
import { Alert, Button, Image, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  updateProfile,
  getProfile,
  getHome,
} from "../../../../store/actions/adminAction";
import { adminReset } from "../../../../store/reducerSlice/admin";
import ManageProfile from "./ManageProfile";
import ResetPasswordFormPopup from "../../../updatePassword/ResetPasswordFormPopup";
import ProfileImage from "../../../../assets/images/profile.svg";
const UpdateProfileForm = () => {
  const [modalShow, setModalShow] = useState(false);
  const [resetPasswordModalShow, setResetPasswordModalShow] = useState(false);
  const { isRecordUpdated, error: apiError } = useSelector(
    (state) => state.admin
  );

  const [clientDetail, setClientDetail] = useState(null);
  const [copied, setCopied] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getProfile()).then(({ payload }) => setClientDetail(payload.data));
  }, []);

  useEffect(() => {
    if (isRecordUpdated) {
      dispatch(getProfile()).then(({ payload }) => {
        if (payload?.success) {
          setClientDetail(payload.data);
          dispatch(adminReset());
        }
      });
    }
  }, [isRecordUpdated]);

  const hideHandle = () => {
    setModalShow(false);
    setResetPasswordModalShow(false);
  };

  const gotoEditHome = () => {
    navigate("/update-profile/edit-home/");
  };

  return (
    <>
      <ManageProfile
        show={modalShow}
        onHide={hideHandle}
        title={"Edit Profile"}
        selectClient={clientDetail}
      />
      <ResetPasswordFormPopup
        onHide={hideHandle}
        resetPasswordRec={clientDetail?.clientId}
        resetPasswordModalShow={resetPasswordModalShow}
        setResetPasswordModalShow={setResetPasswordModalShow}
      />
      <div className="d-flex justify-content-start align-content-center align-items-center block">
        <h1
          className="title text-secondary"
          onClick={() => navigate(`/update-profile`)}
          style={{ cursor: "pointer" }}
        >
          Profile
        </h1>
      </div>

      <div className=" rowBoxDetail mx-auto d-flex flex-wrap md-flex-row  justify-content-start shadow  mb-5 bg-white rounded">
      <div className="ps-4 pe-5 w-15">
          {clientDetail?.logo ? (
            <Image
              className="profileimg"
              src={clientDetail?.logo}
              alt=""
              height={80}
              width={80}
              style={{height:'46px',width:'auto',borderRadius:'0px'}}
            />
          ) : (
            <Image
              className="profileimg"
              src={ProfileImage}
              height={80}
              width={80}
              alt=""
              style={{height:'46px',width:'46px'}}
            />
          )}
        </div>
        <div className="w-75">
          <Row>
            <Col xs={4}>
              {" "}
              <h2 className="objKey" style={{ fontSize: "14px" }}>
                Client Name :
              </h2>
            </Col>
            <Col xs={8}>
              <h2 className="objValue px-4" style={{ fontSize: "14px" }}>
                {clientDetail?.clientName}
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              {" "}
              <h2 className="objKey" style={{ fontSize: "14px" }}>
                Contact Name :
              </h2>
            </Col>
            <Col xs={8}>
              <h2 className="objValue px-4" style={{ fontSize: "14px" }}>
                {clientDetail?.contactName}
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              {" "}
              <h2 className="objKey" style={{ fontSize: "14px" }}>
                Email Id :
              </h2>
            </Col>
            <Col xs={8}>
              <h2 className="objValue px-4" style={{ fontSize: "14px" }}>
                {clientDetail?.clientEmail}
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              {" "}
              <h2 className="objKey" style={{ fontSize: "14px" }}>
                Manage Ward Access :
              </h2>
            </Col>
            <Col xs={8}>
              <h2 className="objValue px-4" style={{ fontSize: "14px" }}>
                {clientDetail?.isWardSystemAccessible ? 'Yes' : 'No'}
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              {" "}
              <h2 className="objKey" style={{ fontSize: "14px" }}>
                UCRT Access :
              </h2>
            </Col>
            <Col xs={8}>
              <h2 className="objValue px-4" style={{ fontSize: "14px" }}>
                {clientDetail?.isUCRTEnabled ? 'Yes' : 'No'}
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              {" "}
              <h2 className="objKey" style={{ fontSize: "14px" }}>
                IMC/Stroke Access :
              </h2>
            </Col>
            <Col xs={8}>
              <h2 className="objValue px-4" style={{ fontSize: "14px" }}>
                {clientDetail?.isIMCEnabled ? 'Yes' : 'No'}
              </h2>
            </Col>
          </Row>
          {clientDetail?.locations && 
          <Row>
            <Col xs={4}>
              {" "}
              <h2 className="objKey" style={{ fontSize: "14px" }}>
                Geography :
              </h2>
            </Col>
            <Col xs={8}>
              <h2 className="objValue px-4" style={{ fontSize: "14px" }}>
                {clientDetail?.locations.length > 0 &&
                  clientDetail?.locations
                    .map((item) => {
                      return item.name;
                    })
                    .join(", ")}
              </h2>
            </Col>
          </Row>
          }
          {clientDetail?.wardTypes && 
          <Row>
            <Col xs={4}>
              {" "}
              <h2 className="objKey" style={{ fontSize: "14px" }}>
                Ward Type :
              </h2>
            </Col>
            <Col xs={8}>
              <h2 className="objValue px-4" style={{ fontSize: "14px" }}>
                {clientDetail?.wardTypes &&
                  clientDetail?.wardTypes
                    .map((item) => {
                      return item;
                    })
                    .join(", ")}
              </h2>
            </Col>
          </Row>
          }
        </div>
      </div>
      <div className=" mx-auto d-flex flex-wrap md-flex-row  justify-content-between   mb-5 ">
        <Button
          className="btn-info"
          onClick={() => setResetPasswordModalShow(true)}
        >
          Update Password
        </Button>
        <Button className="btn-primary" onClick={() => setModalShow(true)}>
          Update
        </Button>
      </div>
    </>
  );
};

export default UpdateProfileForm;
